// import SectionTitle from "../../SectionTitle";
import SocialMediaLinks from "../SocialMediaLinks";
import Title from "../Title";
import SubTitle from "../SubTitle";
// import {useEffect, useRef} from "react";
// import gsapAnim from "../../hooks/useAnim";
import {FiMail, FiNavigation} from "react-icons/fi";

const Contact = () => {
    // const formRef = useRef()

    // useEffect(() => {
    // gsapAnim(formRef.current)
    // gsapAnim('.contactInfoAnim')
    // }, []);

    return (
        <div className={'px-5 py-10'}>
            <Title title={'Contact.'}/>

            {/*<section className="py-20 lg:py-[120px] overflow-hidden relative z-10">*/}
            <div className="md:flex flex-wrap gap-6 lg:justify-between">
                <div className="flex-1 min-w-[300]">
                    <div className="mb-12 lg:mb-0">
                        <SubTitle title='GET IN TOUCH'/>
                        <div className={'ml-6 mt-4 mb-10'}>
                            <SocialMediaLinks/>
                        </div>

                        <div className='max-w-[360px]'>
                            <div
                                data-aos='fade-up'
                                data-aos-delay='000'
                                className='border border-rose-500 rounded-lg p-4 mb-6'>
                                <div className='flex gap-4 items-center mb-2'>
                                    <FiMail className='text-2xl'/>
                                    <h2 className='text-2xl'>Email</h2>
                                </div>
                                <p>nahidferdous240@gmail.com</p>
                            </div>
                            <div
                                data-aos='fade-up'
                                data-aos-delay='200'
                                className='border border-rose-500 rounded-lg p-4'
                            >
                                <div className='flex gap-4 items-center mb-2'>
                                    <FiNavigation className='text-2xl'/>
                                    <h3 className='text-2xl'>Address</h3>
                                </div>
                                <p>Dhaka Bangladesh</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-1">
                    <div className="relative rounded-lg p-2">
                        <form method='POST'>
                            <div data-aos='fade-up' className="mb-6">
                                <input
                                    type="text"
                                    placeholder="Name"
                                    className="w-full rounded py-3 px-[14px] text-nfr-color-900 dark:text-nfr-color-100 bg-white dark:bg-nfr-color-900 text-base resize-none outline-none focus-visible:shadow-none border-b-2 border-transparent focus:border-b-blue-400"
                                />
                            </div>
                            <div data-aos='fade-up' className="mb-6">
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="w-full rounded py-3 px-[14px] text-nfr-color-900 dark:text-nfr-color-100 bg-white dark:bg-nfr-color-900 text-base resize-none outline-none focus-visible:shadow-none border-b-2 border-transparent focus:border-b-blue-400"
                                />
                            </div>
                            <div data-aos='fade-up' className="mb-6">
                                <input
                                    type="text"
                                    placeholder="Subject"
                                    className="w-full rounded py-3 px-[14px] text-nfr-color-900 dark:text-nfr-color-100 bg-white dark:bg-nfr-color-900 text-base resize-none outline-none focus-visible:shadow-none border-b-2 border-transparent focus:border-b-blue-400"
                                />
                            </div>
                            <div data-aos='fade-up' className="mb-6">
                     <textarea
                         rows="6"
                         placeholder="Message"
                         className="w-full rounded py-3 px-[14px] text-nfr-color-900 dark:text-nfr-color-100 bg-white dark:bg-nfr-color-900 text-base resize-none outline-none focus-visible:shadow-none border-b-2 border-transparent focus:border-b-blue-400"
                     ></textarea>
                            </div>
                            <div data-aos='fade-up'>
                                <button
                                    type="submit"
                                    className="w-full text-white bg-rose-500 dark:bg-rose-800 rounded p-3 transition hover:bg-opacity-90"
                                >
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
